/**
 * get border style from viewStyle, or filter only border style then return remain style.
 * @param style
 * @param isFilterBorder true: represent that u want to get only border style from viewStyle.
 */
function filterBorder(style, isFilterBorder) {
    const borderFilter = [
        'borderBottomLeftRadius',
        'borderBottomRightRadius',
        'borderBottomStartRadius',
        'borderBottomEndRadius',
        'borderTopLeftRadius',
        'borderTopRightRadius',
        'borderTopStartRadius',
        'borderTopEndRadius',
        'borderRadius',
        'borderLeftWidth',
        'borderRightWidth'
    ];
    let borderStyle = {};
    let remainStyle = {};
    Object.keys(style).forEach((key) => {
        if (borderFilter.indexOf(key) >= 0) {
            borderStyle[key] = style[key];
        }
        else {
            remainStyle[key] = style[key];
        }
    });
    return isFilterBorder ? borderStyle : remainStyle;
}
function swapBorderStyle(wrapperTextStyle) {
    let { wrappeRightStyle, wrapperLeftStyle } = wrapperTextStyle;
    const rightBorder = filterBorder(wrappeRightStyle, true);
    const rightRemain = filterBorder(wrappeRightStyle, false);
    const leftBorder = filterBorder(wrapperLeftStyle, true);
    const leftRemain = filterBorder(wrapperLeftStyle, false);
    let newWrapperRightStyle = Object.assign(Object.assign({}, rightRemain), leftBorder);
    let newWrapperLeftStyle = Object.assign(Object.assign({}, leftRemain), rightBorder);
    return {
        wrappeRightStyle: newWrapperRightStyle,
        wrapperLeftStyle: newWrapperLeftStyle
    };
}
/**
 * this function used to complete mirror border style, for example:
 * style = { borderBottomLeftRadius: 2 }, we can complete style to { borderBottomLeftRadius: 2, borderBottomRightRadius: 2 }
 */
function completeMirrorBorderStyle(style) {
    if (!style) {
        return {};
    }
    const leftBorderMap = {
        borderBottomLeftRadius: 'borderBottomRightRadius',
        borderTopLeftRadius: 'borderTopRightRadius',
        borderBottomStartRadius: 'borderBottomEndRadius',
        borderTopStartRadius: 'borderTopEndRadius',
        borderLeftWidth: 'borderRightWidth'
    };
    const rightBorderMap = {};
    Object.keys(leftBorderMap).map((key) => {
        let value = leftBorderMap[key];
        rightBorderMap[value] = key;
    });
    const mirrorMap = Object.assign(Object.assign({}, leftBorderMap), rightBorderMap);
    Object.keys(style).map((key) => {
        if (mirrorMap[key]) {
            let value = style[key];
            let mirror = mirrorMap[key];
            style[mirror] = value;
        }
    });
    return style;
}
export { swapBorderStyle, completeMirrorBorderStyle };
